import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    TgButtons2Module,
    TgGridModule,
    TgIconBasicPlusModule,
    TgIconBasicMinusModule,
    TgRackModule,
    TgSvgModule
} from '@trademe/tangram';
import { ShowMoreTextFieldComponent } from './show-more-text-field.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TgButtons2Module,
        TgGridModule,
        TgIconBasicPlusModule,
        TgIconBasicMinusModule,
        TgRackModule,
        TgSvgModule
    ],
    declarations: [ShowMoreTextFieldComponent],
    exports: [ShowMoreTextFieldComponent]
})
export class ShowMoreTextFieldModule {}
